import {
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  ChakraProvider,
} from '@chakra-ui/react';
import HealthPlanMapping from '../HealthPlanPayerMapping/HealthPlanMapping';
import UnmappedHealthPlan from '../UnmappedHealthPlan/UnmappedHealthPlan';
import PayerAddress from '../PayerAddress/PayerAddress';
import HealthPlanMaster from '../HealthPlanMaster/HealthPlanMaster';
import HealthPlanType from '../HealthPlanType/HealthPlanType';
import PayerMaster from '../PayerMaster/PayerMaster';
import { useMsal } from '@azure/msal-react';

export default function HealthPlanMappingNav({
  setTabIndex,
}: {
  setTabIndex: any;
}) {

  const { accounts } = useMsal();
  const userdetails = JSON.parse(localStorage.getItem('userdetails') || '{}');
  const components = userdetails[0]?.components || [];

  const tabs = [
    { name: "Mapped Health Plan", component: "HealthPlanMapping", content: <HealthPlanMapping /> },
    { name: "Unmapped Health Plan", component: "UnmappedHealthPlan", content: <UnmappedHealthPlan /> },
    { name: "Payer Name", component: "PayerMaster", content: <PayerMaster /> },
    { name: "Payer Address", component: "PayerAddress", content: <PayerAddress /> },
    { name: "Health Plan", component: "HealthPlanMaster", content: <HealthPlanMaster /> },
    { name: "Health Plan Type", component: "HealthPlanType", content: <HealthPlanType /> },
  ];

  // Filter tabs based on the components available in userdetails
  const accessibleTabs = tabs.filter((tab) =>
    components.includes(tab.component)
  );

  return (
    <>
      <Tabs mt={2} onClick={setTabIndex(0)}>
        <TabList>
          {accessibleTabs.map((tab, index) => (
            <Tab key={index}>{tab.name}</Tab>
          ))}
        </TabList>
        <TabPanels mt={4}>
          {accessibleTabs.map((tab, index) => (
            <TabPanel key={index} p={0}>
              {tab.content}
            </TabPanel>
          ))}
        </TabPanels>
      </Tabs>
    </>
  );
}
